import { TableBodyCell } from '../../../../../MyTickets.styled';
import { TitleCellProps } from './TitleCell.types';

export const TitleCell = ({ description }: TitleCellProps) => {
  return (
    <TableBodyCell>
      <span className="ellipsis">{description}</span>
    </TableBodyCell>
  );
};
